import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

import { SgdsMasthead } from "@govtechsg/sgds-masthead-react";

import Navbar from "../../Components/NavbarComponent";
import FooterComponent from "../../Components/FooterComponent";
import SideNavComponent from "../../Components/SideNavComponent";
import MastheadAnnouncement from "../../Components/MastheadAnnouncement";

import Endpoint from "../../Components/Endpoint";
import endpointsData from "../../json/sampleEndpts.json";

const NearbyTransportServices = () => {
  const location = useLocation();

  const endpointreturn = (id) => {
    let endpt_elem = endpointsData;
    endpt_elem = endpt_elem.find((item) => item.page_section === id);

    const pythonCode = `import requests
    \nurl = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}"
    \nheaders = {"Authorization": "**********************"}
    \nresponse = requests.get(url, headers=headers)
    \nprint(response.text)`;

    const jsCode = `const url = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}";
const authToken = '**********************';  // Replace with your access token

fetch(url, {
  method: '${endpt_elem.method}',
  headers: {
    'Authorization': \`\${authToken}\`,  // API token for authorization
  }
})
.then(response => response.json())  // Parse response as JSON
.then(data => console.log(data))     // Log the data to the console
.catch(error => console.error('Error:', error));  // Log any errors`;

    return {
      url: endpt_elem.endpoint,
      sampleRequest: endpt_elem.sampleRequest,
      sampleResponse: endpt_elem.sampleResponse,
      method: endpt_elem.method,
      pythonCode,
      jsCode,
    };
  };

  const { state } = location;
  const [activeKey, setActiveKey] = useState("");
  const clickButton = (key) => {
    activeKey === key ? setActiveKey("") : setActiveKey(key);
  };
  useEffect(() => {
    if (state === null) {
      clickButton("0");
    } else {
      clickButton(location.state.toString());
    }
  }, [state]);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapse = (e) => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>
      <Helmet>
        <title>
          Nearby Transportation API to get the nearest MRT and Bus stop | OneMap
          API
        </title>
        <meta
          name="description"
          content="Utilize OneMap's Nearby Transportation API to get the nearest MRT and Bus stop within a radius."
        />
      </Helmet>
      <MastheadAnnouncement />
      <Navbar />
      <div className="row qx-0 mb-5 position-relative">
        <div className="col-1 d-md-none d-inline">
          <div
            className="btn btn-primary d-md-none position-fixed sideBarBtn"
            onClick={(e) => {
              handleCollapse();
              if (isCollapsed) {
                window.scrollTo(0, 0);
              }
            }}
          >
            Show Side Bar
          </div>
        </div>

        <div
          className={`qx-0 col-10 col-md-3 d-md-block  ${
            isCollapsed ? "collapse" : ""
          }`}
        >
          <SideNavComponent />
        </div>

        <div className="col-12 col-md-9 qx-0 px-3">
          <>
            <div
              id="om-search-section"
              className="om-search-section"
              style={{ minHeight: "510px" }}
            >
              <h1 style={{ fontSize: "32px" }} id="search">
                Nearby Transport
              </h1>
              <p
                style={{
                  alignItems: "center",
                  marginTop: "0px",
                  fontSize: "14px",
                }}
              >
                The Nearby Services APIs provide a convenient way to discover
                the closest public transportation options around any location in
                Singapore. Using these endpoints, developers can retrieve
                detailed information about MRT/LRT stations and bus stops within
                a specified radius (up to 5000 meters) from given coordinates.
              </p>
              <p>
                These location-based services return comprehensive details
                including station/stop IDs, names, coordinates, and road names,
                making them ideal for transportation and navigation applications
                that need to help users find their nearest public transport
                options.
              </p>

              <h4>Get Nearest MRT</h4>
              <h3 class="om-reverseGeocode-err">
                <strong class="slate-bold">Possible Error Responses</strong>
              </h3>
              <p>401 - Unauthorized</p>
              <p>400 - Your latitude input is invalid.</p>
              <p>400 - Your longitude input is invalid.</p>
              <p>400 - Both your latitude and longitude are missing.</p>
              <p>
                400 - Your distance should be an integer, bigger than 0 meters
                and less than 5000 meters.
              </p>
              <p>
                403 - User is not authorized to access this resource with an
                explicit deny
              </p>
              <p>429 - Quota exceeded</p>

              <div class="om-theme-wrapper" style={{ "margin-top": "20px" }}>
                <div class="om-theme">
                  <h4 class="om-theme-header">HEADER PARAMETERS</h4>
                </div>
                <div class="om-theme-items">
                  <div class="om-theme-item">
                    <div class="label-method">
                      Authorization<span class="label-type">string</span>
                      <span class="label-required">Required</span>
                    </div>
                    <div class="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="om-search-wrapper"></div>
              <div className="om-search-wrapper">
                <div className="om-search">
                  <h4 className="om-search-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-search-items">
                  <div className="om-search-item">
                    <div className="label-method">
                      latitude
                      <span className="label-type">float</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-search-desc">
                      <p>Latitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                  <div className="om-search-item">
                    <div className="label-method">
                      longitude
                      <span className="label-type">float</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-search-desc">
                      <p>Longitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                  <div className="om-search-item">
                    <div className="label-method">
                      radius_in_meters
                      <span className="label-type">int</span>
                      <span className="label-required">Optional</span>
                    </div>
                    <div className="om-search-desc">
                      <p>Optional. Default is 2000. Max is 5000.</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* bef header params */}
              <Endpoint {...endpointreturn("getNearestMrtStops")} />
            </div>
            &nbsp;
            <br />
            <h4>Get Nearest Bus Stops</h4>
            <h3 class="om-reverseGeocode-err">
              <strong class="slate-bold">Possible Error Responses</strong>
            </h3>
            <p>401 - Unauthorized</p>
            <p>400 - Your latitude input is invalid.</p>
            <p>400 - Your longitude input is invalid.</p>
            <p>400 - Both your latitude and longitude are missing.</p>
            <p>
              400 - Your distance should be an integer, bigger than 0 meters and
              less than 5000 meters.
            </p>
            <p>
              403 - User is not authorized to access this resource with an
              explicit deny
            </p>
            <p>429 - Quota exceeded</p>
            <div class="om-theme-wrapper" style={{ "margin-top": "20px" }}>
              <div class="om-theme">
                <h4 class="om-theme-header">HEADER PARAMETERS</h4>
              </div>
              <div class="om-theme-items">
                <div class="om-theme-item">
                  <div class="label-method">
                    Authorization<span class="label-type">string</span>
                    <span class="label-required">Required</span>
                  </div>
                  <div class="om-reverseGeocode-desc">
                    <p>API token provided by the Authentication Service.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="om-search-wrapper"></div>
            <div className="om-search-wrapper">
              <div className="om-search">
                <h4 className="om-search-header">QUERY PARAMETERS</h4>
              </div>
              <div className="om-search-items">
                <div className="om-search-item">
                  <div className="label-method">
                    latitude
                    <span className="label-type">float</span>
                    <span className="label-required">Required</span>
                  </div>
                  <div className="om-search-desc">
                    <p>Latitude coordinates in WGS84 format.</p>
                  </div>
                </div>
                <div className="om-search-item">
                  <div className="label-method">
                    longitude
                    <span className="label-type">float</span>
                    <span className="label-required">Required</span>
                  </div>
                  <div className="om-search-desc">
                    <p>Longitude coordinates in WGS84 format.</p>
                  </div>
                </div>
                <div className="om-search-item">
                  <div className="label-method">
                    radius_in_meters
                    <span className="label-type">int</span>
                    <span className="label-required">Optional</span>
                  </div>
                  <div className="om-search-desc">
                    <p>Optional. Default is 2000. Max is 5000.</p>
                  </div>
                </div>
              </div>
            </div>
            {/* bef header params */}
            <Endpoint {...endpointreturn("getNearestBusStops")} />
          </>
        </div>
      </div>
      <FooterComponent />
    </>
  );
};
export default NearbyTransportServices;
